<template>
  <div class="">
    <!-- Dialog -->
    <Dialog :title="$t('Write Changelog entries with AI')" v-model="dialogOpen">
      <form @submit.prevent="saveCompanyDetails()">
        <div class="px-4 pt-2 pb-4 sm:px-6 sm:pb-4">
          <p class="text-neutral-600">{{ $t('Describe what {name} is about. FeedBear will use this information to generate a changelog entry draft for you, which you can then edit and publish. You can always change this description under Project Settings.', { name: this.project.name }) }}</p>
          <div class="flex items-center flex-wrap mt-4">
            <textarea
              id="company_details"
              type="text"
              name="project[company_details]"
              class="input"
              v-model="companyDetails"
              maxlength="500"
              :placeholder="$t('{name} is the solution for [target audience] who struggle with [main problem or pain point]. Our product provides [list of benefits] that help you [jobs to be done] so you can achieve [expected results].', { name: this.project.name })"
              rows="7"
            />
          </div>
        </div>
        <div class="px-4 py-3 sm:px-6 flex items-center justify-between">
          <a href="/edit?view=ai_settings" class="text-sm text-neutral-700">
            {{ $t('Edit AI Settings') }}
          </a>
          <div class="flex flex-row items-center">
            <a href="#" class="text-sm text-neutral-700" @click.prevent="disableChangelogSuggestions()">
              {{ $t('Skip') }}
            </a>
            <button type="submit" class="inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 text-sm font-medium text-white ml-4" style="background-color: var(--accent-color)">
              {{ $t('Save & Continue') }}
            </button>
          </div>
        </div>
      </form>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "./dialog";

export default {
  props: ["post", "board", "project", 'show-company-details', 'token', 'companyDetails'],
  data() {
    return {
      dialogOpen: true,
      changelogTitle: "Please wait",
      changelogBody: "Generating Changelog title and body with AI...",
      isLoading: false,
      selectedValue: this.selectedValue,
      companyDetails: this.project.company_details,
    };
  },
  components: {
    Dialog,
  },
  computed:{
  },
  mounted: {
  },
  methods: {
    saveCompanyDetails() {
      let data = new FormData();
      data.append("authenticity_token", this.token);
      data.append("project[company_details]", this.companyDetails);
      Rails.ajax({
        url: `/projects/${this.project.id}/update_company_details`,
        type: "PUT",
        data: data,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          this.$emit("company-details-updated", data);
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    },
    disableChangelogSuggestions() {
      window.location.reload();
    },
  }
}
</script>
<style scoped>
.iconColor:hover svg{
  fill: white;
}
</style>
